import React from 'react';
import ReactModal from 'react-modal';

import StockDetailContent from './layout';

ReactModal.setAppElement('#root');

const customStyles = {
  content: {
    inset: 0,
    height: '100%',
    width: '100%',
  },
  overlay: {
    backgroundColor: 'transparent',
  },
};

class StockDetail extends React.PureComponent {
  render() {
    const { showModal } = this.props;
    return (
      <ReactModal
        isOpen={showModal}
        contentLabel="onRequestClose Example"
        onRequestClose={this.props.handleCloseModal}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
      >
        <StockDetailContent
          className="d-flex flex-row col-12 p-0 h-100"
          {...this.props}
        />
      </ReactModal>
    );
  }
}

export default StockDetail;
